<ng-container [ngSwitch]="viewMode">
  <next-viewer *ngSwitchCase="'web'" [instance$]="instance$"></next-viewer>
  <next-pdf-viewer *ngSwitchCase="'pdf'" [instance$]="instance$"></next-pdf-viewer>
</ng-container>

